import React, {useCallback, useEffect} from 'react';
import TenantPage from './TenantPage';

const AdminTenantPage = ({route, navigation}) => {
  const tenantId = route?.params?.tenantId;
  const tenantName = route?.params?.tenantName;
  const missingTenant = tenantId === undefined || tenantId === null;

  useEffect(() => {
    if (missingTenant) navigation.replace('AdminTenants');
  }, [missingTenant, navigation]);

  const backToTenants = useCallback(
    () => navigation.navigate('AdminTenants'),
    [navigation]
  );

  if (missingTenant) return null;

  return (
    <TenantPage
      key={tenantId}
      tenantId={tenantId}
      tenantName={tenantName}
      onOpenMenu={() => route?.params?.openMenuDrawer?.()}
      onBackToTenants={backToTenants}
    />
  );
};

export default AdminTenantPage;
